import { Card, Col, Row, Skeleton } from 'antd'
import { useTranslation } from '~/common/hooks/useTranslation'

import BodyCommon from '~/components/shared-components/BodyCommon'
import SubCard from '~/components/shared-components/SubCard'
export const LoadingMonsterDetail = () => {
  // eslint-disable-next-line
  const { t } = useTranslation()
  return (
    <BodyCommon>
      <div className="relative container__common mx-auto z-10 relative top-[84px]">
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-0 sm:gap-4 pt-5 sm:pt-12">
          <div className="flex flex-col mb-3 sm:mb-0">
            <div className="relative card__monster_detail h-[530px] flex items-center justify-center">
              <div className="relative flex items-center justify-center w-[60%] h-[70%] max-w-[500px]">
                <Skeleton.Image
                  className=" flex items-center justify-center relative !w-[100%] !h-[100%]"
                  active={true}
                />
              </div>
            </div>

            <Card className="mt-3">
              <Row>
                <Col span={12} className="text-[16px]">
                  <div className="mb-3 font__M__plus font-bold">
                    {t('monsterDetail.contract')}
                  </div>
                  <div className="mb-3 font__M__plus font-bold">
                    {t('monsterDetail.cycle')}
                  </div>
                  <div className="mb-3 font__M__plus font-bold">
                    {t('monsterDetail.minter')}
                  </div>
                  {/* <div className="mb-3 font__M__plus font-bold">
                    {t('monsterDetail.owner')}
                  </div> */}
                  <div className="mb-3 font__M__plus font-bold">
                    {t('monsterDetail.MintType')}
                  </div>
                  <div className="font__M__plus font-bold">
                    {t('monsterDetail.free')}
                  </div>
                </Col>
                <Col span={12} className="text-end">
                  <div className="text-[#40a9ff] mb-3">
                    <Skeleton.Button active={true} size={'small'} block />
                  </div>
                  <div className="mb-3">
                    <Skeleton.Button active={true} size={'small'} block />
                  </div>
                  <div className="mb-3">
                    <Skeleton.Button active={true} size={'small'} block />
                  </div>
                  <div className="mb-3">
                    <Skeleton.Button active={true} size={'small'} block />
                  </div>
                  <div className="mb-3">
                    <Skeleton.Button active={true} size={'small'} block />
                  </div>
                </Col>
              </Row>
            </Card>
          </div>
          <div className="col-span-2">
            <div className="flex items-center">
              <div className="title__monster_detail">Loading...</div>
            </div>
            <Card className="mt-3 mb-8">
              <Row>
                <Col span={12} className="flex items-center">
                  <div className="relative z-10 flex items-center">
                    <img
                      className="mr-2"
                      src={`${process.env.PUBLIC_URL}/imgs/coins/oasis.svg`}
                      alt=""
                      width={32}
                      height={32}
                    />
                    <div className="flex items-center">
                      <div className="flex text-[20px] sm:text-[32px] font-[700]">
                        <Skeleton.Button active={true} size={'small'} block />
                      </div>
                      <span className="text-[16px] sm:text-[20px] flex items-center">
                        <div className="px-3">~</div>{' '}
                        <Skeleton.Button active={true} size={'small'} block />
                      </span>
                    </div>
                  </div>
                </Col>
                <Col span={12} className="text-end">
                  <Skeleton.Button
                    className="mb-1 !w-[15em]"
                    active={true}
                    size={'Large'}
                  />
                </Col>
              </Row>
            </Card>

            <Card className="w-full ">
              <Row className="gap-3">
                <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-4 w-full">
                  <SubCard
                    title={
                      <Skeleton.Button active={true} size={'Large'} block />
                    }
                  >
                    <Skeleton.Button active={true} size={'Large'} block />
                  </SubCard>

                  <SubCard
                    title={
                      <Skeleton.Button active={true} size={'Large'} block />
                    }
                  >
                    <Skeleton.Button active={true} size={'Large'} block />
                  </SubCard>

                  <SubCard
                    title={
                      <Skeleton.Button active={true} size={'Large'} block />
                    }
                  >
                    <Skeleton.Button active={true} size={'Large'} block />
                  </SubCard>
                </div>
              </Row>
            </Card>
          </div>
        </div>

        <div className="mt-5 mb-20"></div>
      </div>
    </BodyCommon>
  )
}

export default LoadingMonsterDetail
